import { io } from 'socket.io-client';
//import store from "@/store";

//const MAX_RECONNECT_ATTEMPTS = 3;
//const RECONNECT_TIMEOUT_MS = 5000;
const PING_INTERVAL = 30000;

//let reconnectionTimerId = null;
//let attemptsFailed = 0;
let debug = false;
let isInitialized = false;
let pingTimerId = null;

const socket = io(process.env.VUE_APP_WEBSOCKET_URL, {
  autoConnect: false,
  transports: ['websocket'],
  //reconnection: false, // if it's needed to have the solution out of the box then remove "connect_error" handler
});

function initSocket(callback = () => {}) {
  //attemptsFailed = 0;

  socket.off('connect');
  socket.on('connect', () => {
    debug && console.warn('WebSocket - connected');

    callback();
    schedulePing();
  });

  socket.off('connect_error');
  socket.on('connect_error', (error) => {
    debug && console.warn('WebSocket: connection failed, attempting to reconnect...');
    debug && console.warn(`WebSocket: connection error ${error}`);

    /*
    attemptsFailed++;

    clearTimeout(reconnectionTimerId);

    if (attemptsFailed <= MAX_RECONNECT_ATTEMPTS) {
      reconnectionTimerId = setTimeout(() => {
        socket.connect();
      }, RECONNECT_TIMEOUT_MS);
    } else {
      store.dispatch("showAlertDialog", {
        title: "Websocket connection error",
        text: `
          The number of reconnection attempts has been exceeded.<br />Please refresh the page for further successful use.
        `,
        permanent: true
      });
    }
    */
  });

  socket.off('disconnect');
  socket.on('disconnect', (reason) => {
    debug && console.warn('WebSocket - disconnected');

    stopPing();

    if (reason === 'io server disconnect') {
      socket.connect();
    } else {
      isInitialized = false;
    }
  });

  socket.off('reconnect');
  socket.on('reconnect', () => {
    schedulePing();
    //attemptsFailed = 0;
  });

  socket.off('reconnect_failed');
  socket.on('reconnect_failed', () => {
    console.error('WebSocket - reconnection failed');
  });

  socket.off('error');
  socket.on('error', (error) => {
    console.error(`WebSocket error: ${error}`);
  });

  socket.offAny();
  socket.onAny((eventName, ...args) => {
    debug && console.warn(`WebSocket received message: event - ${eventName}: ${args}`);
  });

  socket.connect();
}

const doPing = () => {
  if (socket.connected) {
    debug && console.warn('WebSocket - ping sent');

    socket.emit('ping');
    schedulePing();
  } else {
    debug && console.warn('WebSocket - not connected, trying to reconnect');

    socket.connect();
  }
};

const schedulePing = () => {
  clearTimeout(pingTimerId);
  pingTimerId = setTimeout(doPing, PING_INTERVAL);
};

const stopPing = () => {
  debug && console.warn('WebSocket - ping stopped');

  clearInterval(pingTimerId);
  pingTimerId = null;
};

export default {
  init(options = {}, callback = () => {}) {
    if (isInitialized) {
      callback();
      return;
    }

    debug = !!options.debug;

    initSocket(() => {
      isInitialized = true;
      callback();
    });
  },

  on(event, callback) {
    socket.on(event, callback);
  },

  off(event, listener) {
    socket.off(event, listener);
  },

  emit(event, data) {
    socket.emit(event, data);
  },

  disconnect() {
    socket.disconnect();
  },

  connect() {
    socket.connect();
  },

  isDebugEnabled() {
    return !!debug;
  },
};
